/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Addsection1Inputs */

const zh_course_addsection1 = /** @type {(inputs: Course_Addsection1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加子节点`)
};

const en_course_addsection1 = /** @type {(inputs: Course_Addsection1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Sub-node`)
};

const es_course_addsection1 = /** @type {(inputs: Course_Addsection1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir subnodo`)
};

/**
* | output |
* | --- |
* | "Add Sub-node" |
*
* @param {Course_Addsection1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_addsection1 = /** @type {((inputs?: Course_Addsection1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Addsection1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_addsection1(inputs)
	if (locale === "en") return en_course_addsection1(inputs)
	return es_course_addsection1(inputs)
});
export { course_addsection1 as "course_addSection" }